import type { Right } from '@gozoki/tools'
import { Tooltip } from '@mui/material'
import { usePermissionGuard, type RoutePermission } from '~/utils/rbac'
import { ButtonOverrides } from '../../utils/theme/overrides.theme'
import { ConfirmButton } from './ConfirmButton'

interface Props {
  disabled?: boolean
  /** Droit(s) requis pour supprimer. Absent = pas de garde RBAC (legacy). */
  permission?: RoutePermission
  /** Droits v1 exigés tant que le flag `permission-v2` est OFF (où les tuples v2 passent tous). */
  legacyRights?: Right[]
  handleResourceDeletion: () => Promise<unknown>
}

export const ConfirmResourceDeletionButton = ({
  disabled,
  permission,
  legacyRights,
  handleResourceDeletion,
}: Props) => {
  const guard = usePermissionGuard(permission, legacyRights)

  const button = (
    <ConfirmButton
      buttonText="Supprimer"
      buttonProps={{
        variant: 'outlined',
        sx: {
          marginRight: '16px',
          height: '40px',
          ...ButtonOverrides.redOutlined,
        },
        disabled: disabled || !guard.authorized,
      }}
      description="Etes-vous sur de vouloir supprimer cette ressource ?"
      onConfirm={handleResourceDeletion}
      title="Supprimer ?"
      confirmButton={{ text: 'Supprimer' }}
    />
  )

  if (guard.authorized) return button

  // Le bouton désactivé n'émet pas d'évènement pointeur : le `<span>` porte le tooltip.
  return (
    <Tooltip title={guard.tooltip}>
      <span>{button}</span>
    </Tooltip>
  )
}
